import './NotFoundPage.scss';

import React from 'react';
import { connect } from 'react-redux';

import Content from 'components/Content';
import H1 from 'components/H1';

import { updateTitle } from 'containers/App/store/actions';

class NotFoundPage extends React.Component {
    componentDidMount() {
        this.props.updateTitle('404');
    }

    render() {
        return (
            <Content>
                <H1>
                    That page was not found.
                </H1>
                Please use the menu on the left to try again.
            </Content>
        )
    }
}

const mapStateToProps = (state) => {
    return {

    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateTitle: (title) => dispatch(updateTitle(title))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(NotFoundPage);



// WEBPACK FOOTER //
// ./src/containers/NotFoundPage/index.js